/* eslint-disable react/prop-types */
import { navigate } from 'gatsby';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUrlDomain } from 'src/features/layout/slice';

import HomeLayout from './home';
import LoginLayout from './login';
import MeLayout from './me';
import OnboardingLayout from './onboarding';

import { getLayoutIsWhiteLabelUrl } from 'src/features/layout/selectors';
import { getMe } from 'src/features/users/state/selectors';

export default ({ children, pageContext }) => {
  const dispatch = useDispatch();
  const isBrowser = typeof window !== "undefined";
  const isWhiteLabelUrl = useSelector(getLayoutIsWhiteLabelUrl);
  const userData = useSelector(getMe);

  useEffect(() => {
    const applyVisibility = (element) => {
      element.style.display = (isWhiteLabelUrl && !userData) || (userData?.customer?.is_subaccount && userData?.customer?.is_subaccount === true) ? 'none' : 'block';
    };

    const observer = new MutationObserver(() => {
      const element = document.getElementById('customerly-container');
      if (element) {
        applyVisibility(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [isBrowser, isWhiteLabelUrl, userData]);

  useEffect(() => {
    if (isBrowser) {
      dispatch(setUrlDomain(window.location.origin));
    }
  }, [dispatch, isBrowser]);

  switch (pageContext.layout) {
    case 'login':
      return <LoginLayout>{children}</LoginLayout>;
    case 'me':
      return <MeLayout>{children}</MeLayout>;
    case 'onboarding':
      return <OnboardingLayout>{children}</OnboardingLayout>;
    default:
      return <HomeLayout>{children}</HomeLayout>;
  }
};
